import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import { ErrorsSection, LoadingWithDescription } from 'src/components';

import { FormSubmitBtn } from 'src/buttons';
import { UNCONFIRM_PAYROLL_GROUP } from 'src/constants/FormNames';
import { changePayrollGroupConfirm, getConfirmPayrollGroupErrors } from 'src/reducers/employees/employeePays';
import styles from './UnconfirmPayrollGroupModal.scss';

const UnconfirmPayrollGroupInsideForm = ({ handleSubmit, submitting, submit, cancelBtnClick, yearMonthLabel, errors, header }) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <CommonModal.Header hideModal={cancelBtnClick}>{header}</CommonModal.Header>
      <CommonModal.Body>
        <form onSubmit={handleSubmit}>
          <ErrorsSection errors={errors} />
          {submitting && <LoadingWithDescription text={t('features.EmployeePays.components.UnconfirmPayrollGroupModal.salary_cancellation_is_in_process')} />}
          <p className={styles.lead}>
            {yearMonthLabel}
            {t('features.EmployeePays.components.UnconfirmPayrollGroupModal.Cancel_salary_confirmation')}
          </p>
          <div className={styles.caution}>
            <p>{t('features.EmployeePays.components.UnconfirmPayrollGroupModal.cautions')}</p>
            <p>{t('features.EmployeePays.components.UnconfirmPayrollGroupModal.The_following_information_will_change_after_cancelling_confirmation')}</p>
            <div className="u-mt15">
              ①{yearMonthLabel}
              {t('features.EmployeePays.components.UnconfirmPayrollGroupModal.Information_related_to_salary_will_be_deleted')}
              <ul>
                <li>・{t('features.EmployeePays.components.UnconfirmPayrollGroupModal.payslip')}</li>
                <li>・{t('features.EmployeePays.components.UnconfirmPayrollGroupModal.salary_transfer_list')}</li>
                <li>・{t('features.EmployeePays.components.UnconfirmPayrollGroupModal.provision_and_deduction_list')}</li>
              </ul>
            </div>
            <div className="u-mt15">
              {t('features.EmployeePays.components.UnconfirmPayrollGroupModal.Attendance_provision_deduction_are_automatically_calculated_from_the_current_information_However_values_that_were_input_manually_or_edited_with_CSV_will_not_change')}
            </div>
          </div>
        </form>
      </CommonModal.Body>
      <CommonModal.Footer>
        <Button onClick={cancelBtnClick} className="u-mr20">
          {t('features.EmployeePays.components.UnconfirmPayrollGroupModal.cancel')}
        </Button>
        <FormSubmitBtn text={t('features.EmployeePays.components.UnconfirmPayrollGroupModal.confirm')} {...{ submitting, submit }} />
      </CommonModal.Footer>
    </React.Fragment>
  );
};

let UnconfirmPayrollGroupForm = reduxForm({
  form: UNCONFIRM_PAYROLL_GROUP
})(UnconfirmPayrollGroupInsideForm);
const mapStateToProps = state => ({
  errors: getConfirmPayrollGroupErrors(state)
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: data => {
    dispatch(changePayrollGroupConfirm(data, ownProps.selectedPayroll));
    if (typeof ownProps.hideModal === 'function') {
      ownProps.hideModal();
    }
  }
});

UnconfirmPayrollGroupForm = connect(mapStateToProps, mapDispatchToProps)(UnconfirmPayrollGroupForm);

const UnconfirmPayrollGroupModal = ({ isOpen, hideModal, selectedPayroll, yearMonthLabel }) => {
  const { t } = useTranslation();
  const header = t('features.EmployeePays.components.UnconfirmPayrollGroupModal.unconfirmed_salary');

  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal }}>
      <UnconfirmPayrollGroupForm
        hideModal={hideModal}
        cancelBtnClick={hideModal}
        selectedPayroll={selectedPayroll}
        yearMonthLabel={yearMonthLabel}
        header={header}
      />
    </CommonModal>
  );
};

export default UnconfirmPayrollGroupModal;
